import { useWorkspaceConnections } from "@web-app/api";
import { Avatar } from "@web-app/components";
import { Order } from "@web-app/types";

function WorkspaceCell({ data, value }: { data: Order; value: string }) {
  const { data: workspaceConnections } = useWorkspaceConnections();

  if (!data) {
    return value;
  }

  if (!workspaceConnections) {
    return "";
  }

  if (data.workspaceId === data.connectedWorkspaceId) {
    return "";
  }

  const connection = workspaceConnections.find(
    (conn) => conn.connectedWorkspaceId == value || conn.workspaceId == value,
  );

  if (!connection) {
    return "";
  }

  const connectedWorkspace =
    connection.workspaceId == value
      ? connection.workspace
      : connection.connectedWorkspace;

  return (
    <div className="relative flex items-center space-x-3 rounded-lg py-3">
      <div className="flex-shrink-0">
        <Avatar
          size={8}
          name={connectedWorkspace.name}
          image={connectedWorkspace.avatarUrl || ""}
        />
      </div>
      <div className="min-w-0 flex-1">
        <a href="#" className="focus:outline-none">
          <span className="absolute inset-0" aria-hidden="true" />
          <p className="text-sm font-medium text-gray-900">
            {connectedWorkspace.name}
          </p>
        </a>
      </div>
    </div>
  );
}

export default WorkspaceCell;
